import PropTypes from 'prop-types';
// material
import { Box } from '@material-ui/core';

// ----------------------------------------------------------------------

Logo.propTypes = {
  sx: PropTypes.object
};

export default function Logo({ sx }) {
  return (
    <Box sx={{ width: 90, ...sx }}>
      <img src="/static/hub-crea/LOGO-HUB-CREA-HORIZONTAL-FINAL-16.png" alt="HUB CREA LOGO" />
    </Box>
  );
}
